import React, { useState, useEffect, useRef } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { withEDSContext } from '../../EDSContext/EDSContext';
import Popper from '../../Popper';
import makeStyles from '../../makeStyles/makeStylesInternal';
import { spacing30 } from './../../styles/tokens';
import Typography from '../../Typography/Typography';
import PropTypes from 'prop-types';
var useStyles = makeStyles(function () {
  return {
    paperRoot: {
      boxShadow: "\n            0 0.1875rem 0.3125rem -0.0625rem rgba(0,0,0,0.2),\n            0 0.3125rem " + spacing30 + " 0 rgba(0,0,0,0.14),\n            0 0.0625rem 0.875rem 0 rgba(0,0,0,0.12)\n        "
    }
  };
});
var CAL_EVENT_CLASS = 'calendar-event';
var CalendarEvent = function CalendarEvent(props) {
  var classes = useStyles();
  var eventRef = useRef(null);
  var _useState = useState(null),
    anchorEl = _useState[0],
    setAnchorEl = _useState[1];
  var _useState2 = useState(false),
    localOpen = _useState2[0],
    setLocalOpen = _useState2[1];
  var open = props.open,
    target = props.target,
    popperContent = props.popperContent,
    event = props.event,
    popperOpen = props.popperOpen,
    edsContext = props.edsContext;
  var title = /*#__PURE__*/React.createElement("span", null, event.title);
  var closePopperOnKey = function closePopperOnKey(_ref) {
    var key = _ref.key;
    if (key === 'Escape') {
      setLocalOpen(false);
    }
  };
  useEffect(function () {
    target && setLocalOpen(target.querySelector("." + CAL_EVENT_CLASS).dataset.id === "" + event.event.id);
  }, [event, target]);
  useEffect(function () {
    // we want the anchor on the event as a whole, rather than just the label
    // this could / should be moved to logic within the EventWrapper, but that would require a refactor
    popperContent && setAnchorEl(eventRef.current.closest('.rbc-event'));
    document.addEventListener('keydown', closePopperOnKey);
    return function () {
      document.removeEventListener('keydown', closePopperOnKey);
    };
  }, [popperContent]);
  var closePopper = function closePopper() {
    setLocalOpen(false);
    // tell calendar that we closed the popper by the ClickAwayListener
    popperOpen(false);
  };
  if (!popperContent) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "srOnly",
      component: "span"
    }, edsContext.formatMessage('component.Calendar.eventStartDate', {
      date: event.event.start.toDateString()
    }), edsContext.formatMessage('component.Calendar.eventEndDate', {
      date: event.event.end.toDateString()
    })), title);
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: CAL_EVENT_CLASS + " " + CAL_EVENT_CLASS + "-" + event.event.id,
      "data-id": event.event.id,
      ref: eventRef
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "srOnly",
      component: "span"
    }, edsContext.formatMessage('component.Calendar.eventStartDate', {
      date: event.event.start.toDateString()
    }), edsContext.formatMessage('component.Calendar.eventEndDate', {
      date: event.event.end.toDateString()
    })), title, /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: function onClickAway() {
        return closePopper();
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Popper, {
      className: CAL_EVENT_CLASS + "-popper",
      classes: {
        paperRoot: classes.paperRoot
      },
      arrow: true,
      open: localOpen && open,
      anchorEl: anchorEl,
      modifiers: [{
        name: 'flip',
        options: {
          altBoundary: true
        }
      }],
      placement: "top"
    }, typeof popperContent === 'function' ? popperContent(event.event) : popperContent))));
  }
};
CalendarEvent.displayName = 'CalendarEvent';
CalendarEvent.propTypes = {
  event: PropTypes.object,
  target: PropTypes.object,
  open: PropTypes.bool,
  popperContent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  popperOpen: PropTypes.func,
  edsContext: PropTypes.object
};
export default withEDSContext(CalendarEvent);